import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function ScheduledDateDisplay({ scheduledDate, timeSlot }) {
    const getTimeOfDay = (slot) => {
        switch(slot) {
            case 'morning': return 'Morning';
            case 'afternoon': return 'Afternoon';
            case 'evening': return 'Evening';
            default: return '';
        }
    };

    if (!scheduledDate) return null;

    const date = dayjs(scheduledDate).tz("America/New_York");
    const formattedDate = date.format('MMMM D');
    const timeOfDay = getTimeOfDay(timeSlot);

    return (
        <span>
            {formattedDate}, {timeOfDay}
        </span>
    );
}
